import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {WsTaskDTOModel} from '../../models/ws-task-DTO.model';
import {DocumentModel} from '../../models/document.model';
import {ConfigurationService} from '../../services/configuration.service';
import {TasksIconsService} from '../../services/workshopServices/tasks-icons.service';

@Component({
    selector: 'tasks-list',
    templateUrl: './tasks-list.component.html',
    styleUrls: ['./tasks-list.component.scss'],
})
export class TasksListComponent implements OnInit, OnDestroy {

    @Input() document: DocumentModel;
    private display = false;
    private mobileConfig;

    constructor(private configService: ConfigurationService,
                private tasksIcon: TasksIconsService) {
    }

    ngOnInit() {
        this.mobileConfig = this.configService.getMobileConfiguration();

        if ( this.mobileConfig.mobilehireServiceJobTasks2Options ) {
            for (const task of this.document.serviceJob.tasks) {
                if (!task.option || task.option === 3 ) {
                    task.option = 0;
                }
            }
        }

        if ( this.mobileConfig.mobilehireServiceJobTasks5Options ) {
            for (const task of this.document.serviceJob.tasks) {
                if (!task.option) {
                    task.option = 0;
                }
            }
        }
        
    }

    ngOnDestroy() {

    }

    updateOption(task: WsTaskDTOModel) {
        task.option++;
        if (this.mobileConfig.mobilehireServiceJobTasks5Options) {
            if (task.option > 4) {
                task.option = 0;
            }
        } else if (this.mobileConfig.mobilehireServiceJobTasks2Options) {
            if (task.option > 1) {
                task.option = 0;
            }
        }
    }
}
